import React, { useEffect, useState } from 'react';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { adminVolunteerService } from '../services';
import { notifyError, notifyInfo, notifySuccess } from '../utils/toast';

const Volunteers = () => {
    const [volunteers, setVolunteers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchVolunteers();
    }, []);

    const fetchVolunteers = async () => {
        try {
            const response = await adminVolunteerService.getAll();
            setVolunteers(response.data.data || []);
        } catch (error) {
            notifyError('Unable to load volunteer submissions.');
        } finally {
            setLoading(false);
        }
    };

    const updateStatus = async (id, status) => {
        try {
            await adminVolunteerService.updateStatus(id, status);
            notifySuccess(`Volunteer marked as ${status}.`);
            await fetchVolunteers();
        } catch (error) {
            notifyError('Unable to update volunteer status.');
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Delete this volunteer submission?')) return;
        try {
            await adminVolunteerService.delete(id);
            notifySuccess('Volunteer submission deleted.');
            await fetchVolunteers();
        } catch (error) {
            notifyError('Unable to delete volunteer submission.');
        }
    };

    return (
        <div>
            <h1 className="mb-8 text-4xl font-bold text-gray-800">Volunteer Forms</h1>
            {loading ? (
                <div className="py-12 text-center">
                    <div className="inline-block h-12 w-12 animate-spin rounded-full border-b-2 border-emerald-600"></div>
                </div>
            ) : (
                <div className="overflow-hidden rounded-lg bg-white shadow-lg">
                    <div className="overflow-x-auto">
                        <table className="w-full">
                            <thead className="bg-emerald-600 text-white">
                                <tr>
                                    <th className="px-6 py-3 text-left">Name</th>
                                    <th className="px-6 py-3 text-left">Email</th>
                                    <th className="px-6 py-3 text-left">Phone</th>
                                    <th className="px-6 py-3 text-left">City</th>
                                    <th className="px-6 py-3 text-left">Skills</th>
                                    <th className="px-6 py-3 text-left">Availability</th>
                                    <th className="px-6 py-3 text-left">Status</th>
                                    <th className="px-6 py-3 text-left">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {volunteers.map((item) => (
                                    <tr key={item.id} className="border-b hover:bg-gray-50">
                                        <td className="px-6 py-4">{item.name}</td>
                                        <td className="px-6 py-4">{item.email}</td>
                                        <td className="px-6 py-4">{item.phone || '-'}</td>
                                        <td className="px-6 py-4">{item.city || '-'}</td>
                                        <td className="px-6 py-4">{item.skills || '-'}</td>
                                        <td className="px-6 py-4">{item.availability || '-'}</td>
                                        <td className="px-6 py-4">
                                            <select
                                                value={item.status}
                                                onChange={(e) => updateStatus(item.id, e.target.value)}
                                                className="rounded border border-gray-300 px-2 py-1"
                                            >
                                                <option value="new">New</option>
                                                <option value="in_review">In Review</option>
                                                <option value="accepted">Accepted</option>
                                                <option value="rejected">Rejected</option>
                                            </select>
                                        </td>
                                        <td className="px-6 py-4 flex gap-3">
                                            <button
                                                onClick={() => notifyInfo('Use status dropdown to review this submission.')}
                                                className="text-emerald-600 hover:text-emerald-800"
                                                title="Edit"
                                            >
                                                <FaEdit />
                                            </button>
                                            <button
                                                onClick={() => handleDelete(item.id)}
                                                className="text-red-600 hover:text-red-800"
                                                title="Remove"
                                            >
                                                <FaTrash />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Volunteers;
